
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import notifications from "@/lib/notifications";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";
import * as modals from "@/lib/modals";
import NoteFields from "@/components/widgets/NoteFields.vue";
import { onlyWhiteSpace } from "@/lib/utilities";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.uncancelOrderModal,
  components: {
    NoteFields
  }
})
export default class UncancelOrderModal extends Mixins(mixin) {
  orderModule: OrderModule = getModule(OrderModule);
  note: any = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
  orderNumber: string | number = null;
  uncancelling: boolean = false;

  get title() {
    return `Uncancel Order - ${this.orderNumber}`;
  }

  get deliveryForId () {
    if(this.selectedItems == null || this.selectedItems.length == 0)
      return null;
    return this.selectedItems[0].deliveryForId ?? 0;
  }

  get canUncancel() {
    return (
      !this.modalData?.noteIsRequired ||
      (!!this.note && this.note.text && !onlyWhiteSpace(this.note.text))
    );
  }

  load() {
    this.show();
    this.orderNumber = this.selectedItems[0].number;
  }

  noteUpdated(newNote) {
    this.note = JSON.parse(JSON.stringify(newNote));
  }

  async saveModal() {
    try {
      this.uncancelling = true;
      await this.orderModule.uncancelOrder({
        orderNumber: this.orderNumber,
        orderNote: this.note
      });

      for (let index = 0; index < this.selectedItems.length; index++) {
        const selectedOrder = this.selectedItems[index];

        let note = {
          orderHeaderNumber: parseInt(selectedOrder.number),
          text: this.note.text,
          facilityViewable: this.note.facilityViewable !== undefined ? this.note.facilityViewable : true,
          customerViewable: this.note.customerViewable !== undefined ? this.note.customerViewable : true,
          isLegacy: false
        };

        let action = orderModule.createOrderNotes;

        try {
          await action(note);

          this.addActionResult({
            number: selectedOrder.number,
            success: true,
            message: `Note added to order ${selectedOrder.number}.`
          });
        } catch (error) {
          this.addActionResult({
            number: selectedOrder.number,
            success: false,
            message: error.response.data.message,
            errors:
              error.response.data && error.response.data.errors ? error.response.data.errors : null,
            errorMessages:
              error.response.data && error.response.data.errorMessages
                ? error.response.data.errorMessages
                : null
          });
        }
      }

      notifications.success(
        "Order Uncancelled",
        `Order ${this.orderNumber} successfully uncancelled`
      );
      this.hideModal();
    } catch (ex) {
      notifications.error("Uncancel Order", `Failed to uncancel order ${this.orderNumber}`, ex);
    } finally {
      this.uncancelling = false;
    }

    this.refreshOrders();
  }
}
